import axios from 'axios';

let siteCms = null;
let request = null;

const defaultDesktopMenu = Object.freeze([
  { label: 'خانه', href: '/' },
  { label: 'درباره ما', href: '/about-us' },
  { label: 'فروشگاه', href: '/store' },
  { label: 'مجله', href: '/blogs' },
  { label: 'سوالات متداول', href: '/faq' },
  { label: 'تماس با ما', href: '/contact-us' },
]);

const defaultFooterColumns = Object.freeze([
  {
    title: 'دسترسی سریع',
    links: [
      { label: 'خانه', href: '/' },
      { label: 'درباره ما', href: '/about-us' },
      { label: 'فروشگاه', href: '/store' },
      { label: 'مجله', href: '/blogs' },
    ],
  },
  {
    title: 'راهنما',
    links: [
      { label: 'سوالات متداول', href: '/faq' },
      { label: 'تماس با ما', href: '/contact-us' },
      { label: 'شرایط و قوانین', href: '/terms' },
    ],
  },
]);

const defaultSiteCms = Object.freeze({
  globalContent: {
    companyName: 'همراه زر',
    copyright: 'تمامی حقوق برای همراه زر محفوظ است.',
  },
  header: {
    visible: true,
    logo: {
      href: '/',
      src: '/assets/logo/i.png',
      alt: 'همراه زر',
    },
    desktopMenu: defaultDesktopMenu,
    mobileMenu: defaultDesktopMenu,
    actions: {
      dashboardLabel: 'داشبورد',
      loginLabel: 'ورود',
      registerLabel: 'ثبت نام',
      logoutLabel: 'خروج',
      showLogin: true,
      showRegister: true,
    },
  },
  footer: {
    visible: true,
    logo: {
      href: '/',
      src: '/assets/logo/i.png',
      alt: 'همراه زر',
    },
    description: 'خرید و فروش آنلاین طلا با دسترسی سریع، امن و شفاف در همراه زر.',
    columns: defaultFooterColumns,
    contact: {
      address: 'قزوین، محمودآباد نمونه، خیابان امام خمینی، جنب اداره پست، طلا و جواهری میلاد',
      phones: ['028-9145455', '021-33265576'],
      emails: ['info@hamrahzar.com'],
      workingHours: 'شنبه تا چهارشنبه ۱۰ تا ۱۸، پنجشنبه ۱۰ تا ۱۴',
    },
    legalLinks: [{ label: 'شرایط و قوانین', href: '/terms' }],
    socialLinks: [],
    appLinks: [],
  },
  pages: [],
  media: [],
});

function cloneValue(value) {
  return JSON.parse(JSON.stringify(value));
}

function fallbackList(list, fallback) {
  return Array.isArray(list) && list.length ? list : cloneValue(fallback);
}

function mergeSiteCms(payload = {}) {
  const merged = {
    ...cloneValue(defaultSiteCms),
    ...payload,
    globalContent: {
      ...cloneValue(defaultSiteCms.globalContent),
      ...(payload.globalContent || {}),
    },
    header: {
      ...cloneValue(defaultSiteCms.header),
      ...(payload.header || {}),
      logo: {
        ...cloneValue(defaultSiteCms.header.logo),
        ...(payload.header?.logo || {}),
      },
      actions: {
        ...cloneValue(defaultSiteCms.header.actions),
        ...(payload.header?.actions || {}),
      },
    },
    footer: {
      ...cloneValue(defaultSiteCms.footer),
      ...(payload.footer || {}),
      logo: {
        ...cloneValue(defaultSiteCms.footer.logo),
        ...(payload.footer?.logo || {}),
      },
      contact: {
        ...cloneValue(defaultSiteCms.footer.contact),
        ...(payload.footer?.contact || {}),
      },
    },
    pages: Array.isArray(payload.pages) ? payload.pages : [],
    media: Array.isArray(payload.media) ? payload.media : [],
  };

  merged.header.desktopMenu = fallbackList(payload.header?.desktopMenu, defaultSiteCms.header.desktopMenu);
  merged.header.mobileMenu = fallbackList(payload.header?.mobileMenu, merged.header.desktopMenu);
  merged.footer.columns = fallbackList(payload.footer?.columns, defaultSiteCms.footer.columns);
  merged.footer.legalLinks = fallbackList(payload.footer?.legalLinks, defaultSiteCms.footer.legalLinks);
  merged.footer.socialLinks = Array.isArray(payload.footer?.socialLinks) ? payload.footer.socialLinks : [];
  merged.footer.appLinks = Array.isArray(payload.footer?.appLinks) ? payload.footer.appLinks : [];

  return merged;
}

export async function loadSiteCms() {
  if (siteCms) return siteCms;
  if (!request) {
    request = axios.get('/public/site-cms')
      .then((response) => {
        siteCms = mergeSiteCms(response?.data?.data || {});
        window.dispatchEvent(new CustomEvent('site-cms:loaded', { detail: siteCms }));
        return siteCms;
      })
      .catch(() => {
        siteCms = mergeSiteCms();
        window.dispatchEvent(new CustomEvent('site-cms:loaded', { detail: siteCms }));
        return siteCms;
      });
  }
  return request;
}

export function getSiteCms() {
  return siteCms || mergeSiteCms();
}

// Text-only CMS helper.  A missing value intentionally falls back to the
// text already present in the page template, so enabling the CMS never
// changes published content by itself.
export async function getCmsText(key, fallback) {
  const cms = await loadSiteCms();
  const value = cms?.globalContent?.texts?.[key];
  return typeof value === 'string' && value.trim() ? value : fallback;
}
